import { timetableBeta } from "@/api";
import { setTimetableData, setTimetableDataLoading, setTimetableDataError, resetReportsIdsForMassActions, setAudienceFilterMetadata } from "./timetableSlice";
import { typesEnum } from '@pages/Main/Timetable/components/Types/typesEnum';
import { periodModes } from "@pages/Main/Timetable/components/PeriodMode/periodModes";
import store from "@store/redux.store";
import rolesEnum from "@/constant/rolesEnum";
import { fetchWorkingHoursSelectedEmployees } from "./fetchWorkingHoursSelectedEmployees";

export const fetchTimetableData = ({addMe, typeAll} = {}) => async (dispatch, getState) => {
  dispatch(setTimetableDataLoading(true))
  const { filters, weekRange, day, type, periodMode } = getState().timetable;
  const isOneDay = type === typesEnum.oneDay;
  const isManualDayMode = periodMode === periodModes.day;

  
  try {
    const api = isOneDay ? timetableBeta.getDailyTimetableDataСancel : timetableBeta.getWeeklyTimetableDataСancel;
    
    const response = await api(getParams({filters, weekRange, day, type, addMe, typeAll, periodMode}));
    
    const timetableData = response.data.data;

    dispatch(setTimetableData(timetableData));
    dispatch(setAudienceFilterMetadata({
      options: (response.data.audiences ?? []).map((audience) => ({
        value: audience.id,
        label: audience.name
      })),
      hasAudienceLessons: response.data.hasAudienceLessons === true
        || Number(response.data.hasAudienceLessons) === 1
    }));
    dispatch(resetReportsIdsForMassActions())
    dispatch(setTimetableDataError(null))
    if (!isManualDayMode) {
      dispatch(fetchWorkingHoursSelectedEmployees())
    }
  } catch (error) {
    dispatch(setTimetableDataError(error))
  } finally {
    dispatch(setTimetableDataLoading(false))
  }
};


export const getParams = ({filters, weekRange, day, type, addMe, typeAll, periodMode}) => {
    const finalFilters = store.getState()?.profile?.profile?.role === rolesEnum.seminarian ? {
      ...filters,
      seminarians: [store.getState()?.profile?.profile?.id]
    } 
    : 
    {
      ...filters,
      seminarians: !!filters?.direction ? 
                  filters?.seminariansInCourses : 
                  addMe ? [...filters?.seminarians, store.getState()?.profile?.profile?.id] : filters?.seminarians
    };
    if(store.getState()?.profile?.profile?.role === rolesEnum.parent) {
      if(!store.getState()?.parentSelectedChildId) return;
      finalFilters.childrens = [store.getState()?.parentSelectedChildId];
    }

    const isOneDay = type === typesEnum.oneDay;
    const isManualDayMode = periodMode === periodModes.day;

    const params = { 
        filters: finalFilters,
        ...(isOneDay ? {day} : isManualDayMode ? {start: day, end: day} : weekRange),
        type: typeAll ? typesEnum.all : type
    }

    if (typesEnum.isAdditional(type) && !typeAll) {
      params.filters = {
        ...params.filters,
        additionalScheduleTabId: typesEnum.additionalId(type)
      };
    }

    return params;
}
